import {Address, FullName, Permissible, Phone, Resource, updateResource} from "./common"
import {AnnualIncome, EvaluationOutcome, Occupation, SourceOfIncome} from "./application"

export type CustomerBeneficialOwner = {
	type: "beneficialOwner"
	id: string
	attributes: {
		fullName: FullName
		ssn?: Permissible<string>
		passport?: Permissible<string>
		matriculaConsular?: Permissible<string>
		nationality?: Permissible<string>
		address: Permissible<Address>
		dateOfBirth: Permissible<Date>
		email: Permissible<string>
		phone: Permissible<Phone>
		status: EvaluationOutcome
		percentage?: number
		evaluationFlags?: string[]
		maskedSSN?: string
		maskedPassport?: string
		maskedMatriculaConsular?: string
		idTheftScore?: number
		evaluationCodes?: string[]
		occupation?: Occupation
		annualIncome?: AnnualIncome
		sourceOfIncome?: SourceOfIncome
	}
}

export function isCustomerBeneficialOwner(resource: Resource): resource is CustomerBeneficialOwner {
	return resource.type === "beneficialOwner"
}

export type PatchCustomerBeneficialOwnerAttributes = {
	fullName?: FullName
	ssn?: string
	passport?: string
	matriculaConsular?: string
	nationality?: string | null
	address?: Address
	dateOfBirth?: string
	email?: string
	phone?: Phone
	percentage?: number
	occupation?: Occupation
	annualIncome?: AnnualIncome
	sourceOfIncome?: SourceOfIncome
}

export async function patchCustomerBeneficialOwner(
	accessToken: string,
	customerId: string,
	beneficialOwnerId: string,
	attributes: PatchCustomerBeneficialOwnerAttributes
) {
	return await updateResource<CustomerBeneficialOwner>(
		`customers/${customerId}/beneficial-owners/${beneficialOwnerId}`,
		accessToken,
		{
			type: "beneficialOwner",
			attributes,
			relationships: {
				customer: {
					data: {
						type: "businessCustomer",
						id: customerId,
					},
				},
			},
		}
	)
}
